// extracted by mini-css-extract-plugin
export var contentBody = "_bj-9";
export var headerImage = "_bj-2";
export var imageButton = "_bj-7";
export var imageButtonIcon = "_bj-8";
export var imageHeader = "_bj-4";
export var imageHeaderText = "_bj-5";
export var imageOverlay = "_bj-3";
export var imageTitle = "_bj-6";
export var imageWrapper = "_bj-1";
export var taskList = "_bj-a";
export var widget = "_bj-0";